<template lang="pug">
    div
        Button(@click="isOpened=true" long) {{value? $t("groupPattern.certUpload.certificationUpdate"):$t("groupPattern.certUpload.certificationUpload")}}
        Modal(v-model="isOpened" width="800" @on-cancel="handleReset('groupAcmeData')")
            h4(slot="header") {{$t("groupPattern.certUpload.title")}}
            Form(ref="groupAcmeData" :model="groupAcmeData" :rules="ruleValidate" :label-width="150" label-position="left")
                template(v-for="item in uploadItems")
                    FormItem(:prop="item.key")
                        span(slot="label") {{item.name}}
                        Upload(
                            v-model="groupAcmeData[item.key]"
                            :format="item.uploadFormat"
                            :on-error="uploadfail"
                            :on-success="uploadsuccess"
                            name="uploads"
                            ref="uploads"
                            :action="`/api/uploads/${item.uploadEndPoint}`"
                            :show-upload-list="false"
                            :on-format-error="handleFormatError"
                            :data="uploadData"
                            v-bind:with-credentials="true")
                            Button(
                                icon="ios-cloud-upload-outline"
                                style="width: 100%;") {{item.uploadFormat | arrayToString}}
                            br
                            span(v-if="item.uploadFileName!== ''") {{ item.uploadFileName }}
            div(slot="footer")
                Button(type="primary" size="large" long @click="handleSubmit('groupAcmeData')") {{$t("groupPattern.certUpload.clickToUpload")}}
        </div>
</template>
<script>
import { updateGroupCertData } from "@/api/group";
export default {
    props: ["value", "groupAcmeData"],
    data() {
        return {
            uploadKeyMap: {
                certchainUpload: "certchainRaw",
                certpemUpload: "certpemRaw",
                certkeyUpload: "certkeyRaw",
            },
            ruleValidate: {
                certchainRaw: [
                    {
                        required: false,
                        // message: "certchain cannot be empty",
                        // trigger: "blur",
                        // validator: (rule, value, callback) => {
                        //     if (value == "") {
                        //         callback(new Error("請上傳"));
                        //     }
                        //     callback();
                        // }
                    },
                ],
                certpemRaw: [
                    {
                        required: true,
                        message: "certpem cannot be empty",
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (value == "") {
                                callback(new Error("請上傳"));
                            }
                            callback();
                        },
                    },
                ],
                certkeyRaw: [
                    {
                        required: true,
                        message: "certkey cannot be empty",
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (value == "") {
                                callback(new Error("請上傳"));
                            }
                            callback();
                        },
                    },
                ],
            },
            uploadData: {
                groupName: this.$store.state.queryGroupName,
                keypairname: `${this.$store.state.queryGroupName}_acme`,
                commonName: "",
                issuerCommonName: "",
                sanDns: [],
                sanIp: [],
                validityStart: "",
                validityEnd: "",
                emailAddress: "",
            },
            isOpened: false,
            uploadItems: [
                {
                    name: this.$t("groupPattern.certUpload.certPem"),
                    key: "certpemRaw",
                    uploadFormat: ["pem", "crt", "cer"],
                    uploadEndPoint: "certpem",
                    uploadFileName: "",
                    successUpdateFields: [
                        "commonName",
                        "issuerCommonName",
                        "sanDns",
                        "sanIp",
                        "validityStart",
                        "validityEnd",
                        "emailAddress",
                        "certpemRaw",
                    ],
                },
                {
                    name: this.$t("groupPattern.certUpload.certChain"),
                    key: "certchainRaw",
                    uploadFormat: ["pem", "crt", "cer"],
                    uploadEndPoint: "certchain",
                    uploadFileName: "",
                    successUpdateFields: ["certchainRaw"],
                },
                {
                    name: this.$t("groupPattern.certUpload.certKey"),
                    key: "certkeyRaw",
                    uploadFormat: ["key"],
                    uploadEndPoint: "certkey",
                    uploadFileName: "",
                    successUpdateFields: ["certkeyRaw"],
                },
            ],
        };
    },
    methods: {
        async handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.updateCertData();
                    this.$refs.groupAcmeData.resetFields();
                    this.uploadItems.map((item) => (item.uploadFileName = ""));
                    this.isOpened = false;
                    this.$emit("reloadData");
                } else {
                    this.$Message.error("請確實上傳憑證");
                }
            });
        },
        async updateCertData() {
            await updateGroupCertData({
                groupName: this.$store.state.queryGroupName,
                data: this.uploadData,
            })
                .then((res) => {
                    if (res.success == true) {
                        this.$Notice.success({
                            title: this.$t("global.success"),
                            desc: `${res.message}`,
                        });
                    } else {
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${res.data.message}`,
                        });
                    }
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.data.message}`,
                    });
                });
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.uploadItems.map((item) => (item.uploadFileName = ""));
        },
        uploadfail(error, response, fileList) {
            var filename = response.uploadname;
            this.uploadData[filename] = "";
            this.$Notice.warning({
                title: "檔案錯誤",
                desc: `${response.message}`,
            });
        },
        uploadsuccess(response, file, fileList) {
            if (response.success == false) {
                return this.$Notice.warning({
                    title: "檔案錯誤",
                    desc: `${response.message}`,
                });
            }
            var key = this.uploadKeyMap[response.uploadname];

            this.groupAcmeData[key] = response.uploadPerformResult[key];

            var item = this.uploadItems.filter((item) => item.key == this.uploadKeyMap[response.uploadname])[0];
            item.uploadFileName = response.uploadPerformResult[response.uploadname];

            // 更新指定欄位
            item.successUpdateFields.forEach((key) => {
                this.uploadData[key] = response.uploadPerformResult[key];
            });
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: this.$t("global.errorFile"),
                desc: `${file.name} ` + this.$t("rcmtable.validateUnsupportedText"),
            });
        },
    },
    mounted() {},
    watch: {
        groupAcmeData: {
            immediate: true,
            deep: true,
            handler: function (newValue, oldValue) {
                // console.log(newValue, oldValue);
            },
        },
    },
    filters: {
        arrayToString: function (text) {
            return Array.isArray(text) ? text.join(", ") : text;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/CertModal.vue